import styled from 'styled-components'

import { Colors } from 'styles'

export const TableWrap = styled.div`
  overflow-x: auto;
  border-bottom: 1px solid ${Colors.gray40};
`
